import { ReactNode } from "react";

type SettingsCardProps = {
  title?: string;
  description?: string;
  /** Sits on the right of the header, e.g. an "Add" button. */
  actions?: ReactNode;
  children: ReactNode;
};

export function SettingsCard({
  title,
  description,
  actions,
  children,
}: SettingsCardProps) {
  const hasHeader = title || description || actions;

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5">
      {hasHeader && (
        <div className="mb-3 flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            {title && (
              <h3 className="text-base font-semibold text-gray-900">{title}</h3>
            )}
            {description && (
              <p className="mt-1 text-sm text-gray-600">{description}</p>
            )}
          </div>
          {actions}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
}
